import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RequiredAuth } from 'common/components/required-auth';
import { RequiredCustomization } from 'common/components/required-customization';
import { RequiredPolicyConsent } from 'common/components/required-policy-consent';
import { BenefitAdminObserver } from 'common/components/benefit-admin-observer';
import { OnlyCreateCompany } from 'common/components/only-create-company';
export var AuthorizedAppGuard = function (_a) {
    var layout = _a.layout;
    return (_jsx(RequiredAuth, { children: _jsxs(_Fragment, { children: [_jsx(OnlyCreateCompany, {}), _jsx(RequiredCustomization, { children: _jsxs(_Fragment, { children: [_jsx(RequiredPolicyConsent, {}), _jsx(BenefitAdminObserver, {}), layout] }) })] }) }));
};
